import React, { useEffect, useState } from "react";
import Training_Report_Filter from "./training_report_filter/Training_Report_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Training_Report_Table from "./training_report_table/Training_Report_Table";
import {
  GetCustomerReport,
  GetTriningReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../../../src/features/admin/quality_management/resource_requirement/training_details/Slice";
import { GETAuthLogin } from "../../../../../../../features/auth/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Training_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const personaldetails = useSelector((state) => state.training_details);
  const [searchParams, setSearchParams] = useState({
    specialization_id: "",
    designation_id: "",
    end_date: "",
    start_date: "",
  });
  const authdetails = useSelector((state) => state.auth);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.training_report.Report);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: personaldetails.per_page,
        training_type_id: searchParams?.training_type_id?.value,
        training_field_id: searchParams?.training_field_id?.value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
    dispatch(GETAuthLogin());
  }, [dispatch, currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetTriningReport({
        page: 1,
        per_page: personaldetails.per_page,
        training_type_id: searchParams?.training_type_id?.value,
        training_field_id: searchParams?.training_field_id?.value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Training_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Training_Report_Table
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          personaldetails={personaldetails}
        />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Training Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Training_Report;
